import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@core';
import { AuthFooter, ScrollingImages } from '@routes/auth/_components';
import { getStoreLink } from '@configs';
import { Button, Container } from '@ui-core';
import { isNativeDevice } from '@utils';

const NativeFeatureGuard: React.FC<PropsWithChildren> = ({
  children,
}: PropsWithChildren) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!isNativeDevice)
    return (
      <Container className="h-dvh justify-center md:flex-row-reverse">
        <ScrollingImages className="hidden h-1/2 w-full md:block md:h-dvh md:w-1/2" />
        <div className="flex w-full flex-1 flex-col justify-between px-6 md:w-1/2 md:overflow-auto">
          <div className="flex flex-1 flex-col justify-center">
            <h2>{t('nativeFeatureGuard.title')}</h2>
            <span className="sub-header-1 pt-2 text-primary-400">
              {t('nativeFeatureGuard.description')}
            </span>

            <div className="flex w-full flex-col items-center justify-center self-center">
              <Button
                shape="full"
                size="large"
                textKey="common.buttonLabel.useApp"
                className="mt-10"
                onClick={() => window.open(getStoreLink(), '_blank')}
              />
              <Button
                shape="full"
                size="large"
                textKey="common.buttonLabel.goHome"
                className="mt-4"
                variant="outline"
                onClick={() =>
                  navigate(ROUTES.dashboard.home, { replace: true })
                }
              />
            </div>
          </div>
          <AuthFooter />
        </div>
      </Container>
    );

  return children;
};

export default NativeFeatureGuard;
